import { useRef } from "react";
import { FileCsv, FileText, UploadSimple } from "@phosphor-icons/react";
import { inputCls } from "@/lib/ui";

export function looksLikeCsv(text) {
  const lines = text.trim().split(/\r?\n/).filter((l) => l.trim());
  if (lines.length < 2) return false;
  const sep = (lines[0].match(/\t/g) || []).length > 0 ? "\t" : ",";
  const cols = lines[0].split(sep).length;
  if (cols < 3) return false;
  return lines.filter((l) => Math.abs(l.split(sep).length - cols) <= 1).length / lines.length >= 0.8;
}

export const CsvInput = ({ value, onChange }) => {
  const ref = useRef(null);
  const text = value.trim();
  const csv = looksLikeCsv(text);
  const rows = text.split(/\r?\n/).filter((l) => l.trim()).length - 1;
  const words = text ? text.split(/\s+/).length : 0;

  const onFile = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = () => onChange(String(reader.result));
    reader.readAsText(f);
    e.target.value = "";
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <button type="button" onClick={() => ref.current?.click()} className="flex items-center gap-2 text-sm text-[var(--o-muted)] hover:text-[var(--o-fg)] transition-colors" data-testid="csv-upload-button">
          <UploadSimple size={14} /> Load file (.csv, .txt, .md)
        </button>
        <span className="font-mono text-[11px] text-[var(--o-muted2)] flex items-center gap-1.5" data-testid="csv-row-count">
          {!text ? <>Empty · CSV or plain text</> : csv ? <><FileCsv size={14} /> CSV · {rows} rows · stored verbatim</> : <><FileText size={14} /> Text · {words} words · stored verbatim</>}
        </span>
      </div>
      <input ref={ref} type="file" accept=".csv,.tsv,.txt,.md,text/csv,text/plain,text/markdown" className="hidden" onChange={onFile} data-testid="csv-file-input" />
      <textarea
        className={`${inputCls} font-mono text-xs leading-relaxed min-h-[150px] resize-y`}
        placeholder={"Paste a ManagementOS CSV export…\ngoal,owner,target,status,last_update\n20-customer outreach,Head of Sales,20 by 30 Jun,Behind,2026-06-28\n\n…or plain notes: H2 goals, targets, owners, open questions."}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete="off"
        spellCheck={false}
        data-testid="csv-textarea"
      />
    </div>
  );
};
